import { DocumentManager } from '../../RichTextEditor';
import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useCommentFormState() {
  return useAppState();
}

export function useCommentFormActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((state) => ({
      ...state,
      commentForm: {
        documentManager: new DocumentManager({ startDocumentComponentType: 'DocumentParagraph' }),
      },
    }));
  }

  // Bridges the editor helpers' setState API (which expects { documentManager } at the
  // top level) with AppContext's nested state shape ({ commentForm: { documentManager } }).
  function setEditorState(updater) {
    dispatch((appState) => {
      const prevEditorState = {
        documentManager: appState.commentForm.documentManager,
        feedbackMessage: appState.feedbackMessage,
        feedbackVariant: appState.feedbackVariant,
      };
      const nextEditorState = typeof updater === 'function' ? updater(prevEditorState) : updater;
      return {
        ...appState,
        commentForm: {
          ...appState.commentForm,
          documentManager: nextEditorState.documentManager,
          activeStyleTypes: nextEditorState.activeStyleTypes,
          activeFormat: nextEditorState.activeFormat,
          activeHref: nextEditorState.activeHref,
        },
        feedbackMessage: nextEditorState.feedbackMessage !== undefined ? nextEditorState.feedbackMessage : appState.feedbackMessage,
        feedbackVariant: nextEditorState.feedbackVariant !== undefined ? nextEditorState.feedbackVariant : appState.feedbackVariant,
      };
    });
  }

  function onResponse(response) {
    dispatch((state) => ({ ...state, ...response }));
  }

  function onError(feedback) {
    dispatch((state) => ({ ...state, ...feedback }));
  }

  function clearFeedback() {
    dispatch((state) => ({
      ...state,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    setEditorState,
    onResponse,
    onError,
    clearFeedback,
  };
}
